<template>
  <div>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body c>
          <b-card-header>
            <h5 class="float-left"><i class='fa fa-calculator'></i> VIP Level - Payment Option</h5>
          </b-card-header>
          <b-card-body>
            <div class="overflow-auto">
              <div class="b-table-sticky-header table-responsive">
                <table class="table b-table table-responsive-sm" v-if="!fetching">
                  <thead>
                    <tr>
                      <th class="table-b-table-default">S.No</th>
                      <th class="table-b-table-default">Name</th>
                      <th v-for="(val, key) in viplevel" :key="`${key}-paymentmethod`" class="table-b-table-default">
                        {{ val.Name }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(pval, pkey) in paymentMethod" :key="`${pkey}-viplevel`">
                      <td>{{ pkey+1 }}</td>
                      <td>
                        {{ pval.Name }}
                        <template>
                          <b-badge v-if="pval.Maintenance === 0" variant="success">Enabled</b-badge>
                          <b-badge v-if="pval.Maintenance === 1" variant="danger">Maintenance</b-badge>
                        </template>
                      </td>
                      <td v-for="(val, key) in viplevel" :key="`${key}-paymentval`">
                        <c-switch ref="displayStatus" :disabled="disabled" type="text" variant="success" on="On" off="Off" :pill="true" :checked="checkmaplist(val.Id, pval.Id)" @change="showUpdatePaymentOptionStatus(val.Id, val.Name, pval.Id, pval.Name)"/>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-modal title="Change Display Status" class="modal-success" v-model="confirmChange" okTitle="Confirm" @ok="updatePaymentStatus" @hide="cancelUpdatePaymentStatus" ok-variant="success">
      <h5>
        Are you sure you want to <strong>{{ uStatus ? 'Enable' : 'Disable' }}</strong> payment status for <strong>{{ uLevel }}</strong> <strong>{{ uPayment }} ?</strong>
      </h5>
    </b-modal>
  </div>
</template>

<script>
  import cSwitch from '../../../../components/Switch'
  import VueNotifications from 'vue-notifications'
  import {Events} from '../../../../events.js'
  export default {
    name: 'vip-payment-option-matrix-view',
    data: () => {
      return {
        viplevel: [],
        paymentMethod: [],
        maplist: [],
        fetching: true,
        confirmChange: false,
        uLevelId: '',
        uLevel: '',
        uPaymentId: '',
        uPayment: '',
        uStatus: '',
        disabled: false
      }
    },
    components: {
      cSwitch
    },
    methods: {
      async getVIPList () {
        try {
          let { data } = await this.$http.get(this.API_ENDPOINT + '/payment/viplevel/levels', {headers: { 'Content-Type': 'application/json' }})
          this.viplevel = data.levels
        } catch (error) {
          throw new Error(error)
        }
      },
      checkmaplist (levelId, paymentId, data = false) {
        var found = this.maplist.find(x => (x.LevelId === levelId && x.PaymentId === paymentId))
        if (data) return found
        return (found && Object.keys(found).length !== 0 && found.Status === 1)
      },
      async getPaymentMethodList () {
        try {
          let { data } = await this.$http.get(this.API_ENDPOINT + '/payment/paymentMethod/getList?type=1', { headers: { 'Content-Type': 'application/json' } })
          this.paymentMethod = data.list
        } catch (error) {
          throw new Error(error)
        }
      },
      async getVipPaymentMap () {
        try {
          let { data } = await this.$http.get(this.API_ENDPOINT + '/payment/levelmap/maplist', { headers: { 'Content-Type': 'application/json' } })
          this.maplist = data.maplist
        } catch (error) {
          throw new Error(error)
        }
      },
      showUpdatePaymentOptionStatus (levelId, level, paymentId, payment, status) {
        var data = this.checkmaplist(levelId, paymentId, true)
        this.uLevelId = levelId
        this.uLevel = level
        this.uPaymentId = paymentId
        this.uPayment = payment
        this.uStatus = data ? !data.Status : true
        this.confirmChange = true
      },
      async updatePaymentStatus () {
        try {
          await this.$http.post(this.API_ENDPOINT + '/payment/levelmap/changestatus', {
            levelId: this.uLevelId,
            paymentId: this.uPaymentId,
            status: this.uStatus
          }, {
            headers: { 'Content-Type': 'application/json' }
          })
          await this.getVipPaymentMap()
          this.cancelUpdatePaymentStatus()
        } catch (err) {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        }
      },
      cancelUpdatePaymentStatus () {
        this.fetching = true
        this.uLevelId = ''
        this.uLevel = ''
        this.uPaymentId = ''
        this.uPayment = ''
        this.confirmChange = false
        setTimeout(() => { this.fetching = false }, 0)
      },
      checkAccessPrivilege (module) {
        if (!module) return true
        return this.PRIVILEGE.includes(module)
      }
    },
    async created () {
      try {
        await Promise.all([
          this.getVIPList(),
          this.getPaymentMethodList(),
          this.getVipPaymentMap()
        ])
        this.disabled = !this.checkAccessPrivilege('Payment.Level.Options.Change')
        this.fetching = false
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      }
    }
  }
</script>

<style scoped>
.b-table-sticky-header {
  max-height: 480px;
}
</style>


// WEBPACK FOOTER //
// src/views/payment/viplevel/PaymentOption/VIPLevelPaymentMatrixView.vue